import {
	Button,
	Col,
	Divider,
	Flex,
	Form,
	notification,
	Row,
	Popconfirm,
} from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashAlt } from "@fortawesome/pro-regular-svg-icons";

import { DELETE } from "../../../../providers/useAxiosQuery";
import validateRules from "../../../../providers/validateRules";
import FloatInput from "../../../../providers/FloatInput";
import FloatSelect from "../../../../providers/FloatSelect";
import notificationErrors from "../../../../providers/notificationErrors";

export default function FormListQuestionOptions(props) {
	const { form, fieldsOption, addOption, removeOption } = props;

	const { mutate: mutateDeleteOption, isLoading: isLoadingDeleteOption } =
		DELETE("api/form_question_option", "form_question_option_delete");

	const handleDeleteOption = (name, remove) => {
		if (fieldsOption.length > 1) {
			let form_question_options = form.getFieldValue("form_question_options");

			let form_question_option = form_question_options[name];

			if (form_question_option && form_question_option.id) {
				mutateDeleteOption(form_question_option, {
					onSuccess: (res) => {
						if (res.success) {
							notification.success({
								message: "Option",
								description: res.message,
							});
							remove(name);
						} else {
							notification.error({
								message: "Option",
								description: res.message,
							});
						}
					},
					onError: (err) => {
						notificationErrors(err);
					},
				});
			} else {
				remove(name);
			}
		} else {
			notification.warning({
				message: "Warning",
				description: "At least one option is required.",
			});
		}
	};

	return (
		<Row gutter={[10, 0]} className="form-list-item-option-container">
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				{fieldsOption.map(({ key, name, ...restField }) => (
					<Flex key={key} vertical>
						<Flex
							gap={10}
							align="start"
							className="form-list-item-option-wrapper"
						>
							<Row gutter={[10, 0]}>
								<Col xs={24} sm={24} md={24} lg={24} xl={24}>
									<Form.Item
										{...restField}
										name={[name, "option"]}
										rules={[validateRules.required]}
									>
										<FloatInput label="Option" placeholder="Option" required />
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={24} lg={12} xl={12}>
									<Form.Item
										{...restField}
										name={[name, "scale"]}
										rules={[validateRules.required]}
									>
										<FloatInput label="Scale" placeholder="Scale" required />
									</Form.Item>
								</Col>

								<Col xs={24} sm={24} md={24} lg={12} xl={12}>
									<Form.Item {...restField} name={[name, "sub_option_type"]}>
										<FloatSelect
											label="Sub Option"
											placeholder="Sub Option"
											allowClear
											options={[
												{
													label: "Text (Input)",
													value: "Text (Input)",
												},
												{
													label: "Number (Input)",
													value: "Number (Input)",
												},
												{
													label: "Radio (Button)",
													value: "Radio (Button)",
												},
												{
													label: "Checkbox",
													value: "Checkbox",
												},
												{
													label: "Select (Dropdown)",
													value: "Select (Dropdown)",
												},
												{
													label: "Date (Datepicker)",
													value: "Date (Datepicker)",
												},
												{
													label: "Time (Timepicker)",
													value: "Time (Timepicker)",
												},
											]}
											onChange={(value) => {
												if (
													value === "Checkbox" ||
													value === "Radio (Button)" ||
													value === "Select (Dropdown)" ||
													value === "Text (Ranking)"
												) {
													let form_question_options =
														form.getFieldValue("form_question_options") || {};
													form_question_options[name]["sub_options"] =
														form_question_options[name]["sub_options"] || [{}];

													form.setFieldValue(
														"form_question_options",
														form_question_options
													);
												}
											}}
										/>
									</Form.Item>
								</Col>

								<Form.Item shouldUpdate noStyle>
									{() => {
										let form_question_options = form.getFieldValue(
											"form_question_options"
										)
											? form.getFieldValue("form_question_options")[name]
											: [];
										let options = [
											"Checkbox",
											"Radio (Button)",
											"Select (Dropdown)",
											"Text (Ranking)",
										];

										if (
											form_question_options &&
											form_question_options.sub_option_type
										) {
											return (
												<>
													<Col xs={24} sm={24} md={24} lg={24} xl={24}>
														<Form.Item
															{...restField}
															name={[name, "question_option"]}
														>
															<FloatInput
																label="Question"
																placeholder="Question"
															/>
														</Form.Item>
													</Col>

													{form_question_options.sub_option_type ===
													"Checkbox" ? (
														<Col xs={24} sm={24} md={24} lg={24} xl={24}>
															<Form.Item
																{...restField}
																name={[name, "max_checkbox"]}
																rules={[validateRules.required]}
															>
																<FloatInput
																	label="Max Checkbox"
																	placeholder="Max Checkbox"
																	type="number"
																	required
																/>
															</Form.Item>
														</Col>
													) : null}

													{form_question_options &&
													options.includes(
														form_question_options.sub_option_type
													) ? (
														<Col xs={24} sm={24} md={24} lg={24} xl={24}>
															<Form.List name={[name, "sub_options"]}>
																{(
																	fieldsSubOption,
																	{ add: addSubOption, remove: removeSubOption }
																) => (
																	<SubOption
																		form={form}
																		parentSubKey={name}
																		fieldsSubOption={fieldsSubOption}
																		addSubOption={addSubOption}
																		removeSubOption={removeSubOption}
																	/>
																)}
															</Form.List>
														</Col>
													) : null}
												</>
											);
										}
									}}
								</Form.Item>
							</Row>
							<div className="btn-delete-wrapper">
								<Popconfirm
									title="Are you sure to delete this option?"
									onConfirm={() => handleDeleteOption(name, removeOption)}
									okText="Yes"
									cancelText="No"
									className="btn-delete-option"
								>
									<Button
										type="link"
										icon={<FontAwesomeIcon icon={faTrashAlt} />}
										loading={isLoadingDeleteOption}
										className="btn-delete"
									/>
								</Popconfirm>
							</div>
						</Flex>
						<Divider className="mt-5" />
					</Flex>
				))}
			</Col>

			<Col
				xs={24}
				sm={24}
				md={24}
				lg={24}
				xl={24}
				className="btn-add-option-wrapper"
			>
				<Button
					type="dashed"
					onClick={() => addOption()}
					block
					icon={<FontAwesomeIcon icon={faPlus} />}
					className="btn-add"
				>
					ADD OPTION
				</Button>
			</Col>
		</Row>
	);
}

const SubOption = ({
	form,
	parentKey,
	parentSubKey,
	fieldsSubOption,
	addSubOption,
	removeSubOption,
}) => {
	const { mutate: mutateDeleteOption, isLoading: isLoadingDeleteOption } =
		DELETE("api/form_question_option", "form_question_option_delete");

	const handleDeleteOption = (name) => {
		if (fieldsSubOption.length > 0) {
			let form_question_options = form.getFieldValue("form_question_options")[
				parentSubKey
			];

			if (form_question_options) {
				if (
					form_question_options.sub_options &&
					form_question_options.sub_options.length
				) {
					let sub_option = form_question_options.sub_options[name];
					console.log("sub_option:", sub_option);

					if (sub_option && sub_option.id) {
						mutateDeleteOption(sub_option, {
							onSuccess: (res) => {
								if (res.success) {
									notification.success({
										message: "Sub Option",
										description: res.message,
									});
									removeSubOption(name);
								} else {
									notification.error({
										message: "Sub Option",
										description: res.message,
									});
								}
							},
							onError: (err) => {
								notificationErrors(err);
							},
						});
					} else {
						removeSubOption(name);
					}
				} else {
					removeSubOption(name);
				}
			} else {
				removeSubOption(name);
			}
		} else {
			removeSubOption(name);
		}
	};

	return (
		<Row gutter={[10, 0]} className="form-list-item-sub-option-container">
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				{fieldsSubOption.map(({ key, name, ...restField }) => (
					<Flex key={key} vertical>
						<Flex
							gap={10}
							align="start"
							className="form-list-item-sub-option-wrapper"
						>
							<Row gutter={[10, 0]}>
								<Col xs={24} sm={24} md={24} lg={12} xl={12}>
									<Form.Item
										{...restField}
										name={[name, "option"]}
										rules={[validateRules.required]}
									>
										<FloatInput label="Option" placeholder="Option" required />
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={24} lg={12} xl={12}>
									<Form.Item
										{...restField}
										name={[name, "scale"]}
										rules={[validateRules.required]}
									>
										<FloatInput label="Scale" placeholder="Scale" required />
									</Form.Item>
								</Col>
							</Row>
							<div className="btn-delete-wrapper">
								<Popconfirm
									title="Are you sure to delete this option?"
									onConfirm={() => handleDeleteOption(name)}
									okText="Yes"
									cancelText="No"
									className="btn-delete-option"
								>
									<Button
										type="link"
										icon={<FontAwesomeIcon icon={faTrashAlt} />}
										className="btn-delete"
										loading={isLoadingDeleteOption}
									/>
								</Popconfirm>
							</div>
						</Flex>

						<Divider className="mt-5" />
					</Flex>
				))}
			</Col>

			<Col
				xs={24}
				sm={24}
				md={24}
				lg={24}
				xl={24}
				className="btn-add-option-wrapper mb-20"
			>
				<Button
					type="dashed"
					onClick={() => addSubOption()}
					block
					icon={<FontAwesomeIcon icon={faPlus} />}
					className="btn-add"
				>
					ADD SUB OPTION
				</Button>
			</Col>
		</Row>
	);
};
